/* eslint-disable @typescript-eslint/no-unused-vars */
/* Autogenerated, do not modify! */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import SvgIcon from '@move-ui/svg-icon';
export const ArrowDownIcon = (_a) => {
    var { fillColor = 'currentColor', strokeColor = 'currentColor' } = _a, svg = __rest(_a, ["fillColor", "strokeColor"]);
    return (React.createElement(SvgIcon, Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24", "data-icon": true }, svg),
        React.createElement("path", { fill: fillColor, fillRule: "evenodd", d: "M7 9.75a0.75 0.75 0 011.295-0.515L12 13.158l3.705-3.923a0.75 0.75 0 011.09 1.03l-4.25 4.5a0.75 0.75 0 01-1.09 0l-4.25-4.5A0.747 0.747 0 017 9.75z", clipRule: "evenodd" })));
};
//# sourceMappingURL=ArrowDownIcon.js.map